<div class="table-enterprise-element">
    <nz-table #expandTable [nzData]="dataSource" [nzFrontPagination]="false"
              [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
              class="ant-table-no-placeholder-border-bottom" nzBordered>
      <thead>
      <tr>
        <th class="text-center" nzWidth="40px">
          {{
            "enterprise_contract.panel_document_view.table_signing_flow.header.order"
              | translate
          }}
        </th>
        <th>
          {{
            "enterprise_contract.panel_document_view.table_signing_flow.header.party_name"
              | translate
          }}
        </th>
        <th nzWidth="25%" class="text-center">
          {{
            "enterprise_contract.panel_document_view.table_signing_flow.header.progress"
              | translate
          }}
        </th>
        <th nzWidth="25px"></th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let data of expandTable.data; let i = index">
        <tr class="tr-enterprise-data">
          <td class="text-center">{{ data.order || i + 1 }}</td>
          <td class="enterprise-name">{{ getPartyName(data) }}</td>
          <td class="text-center">
            <nz-tag *ngIf="data.status == enumContractEnterpriseStatus.NO_PROCESS">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.waiting"
                  | translate
              }}
            </nz-tag>
            <nz-tag *ngIf="isProcessingEnterprise(data.status) && !isStoppedDocument()" [nzColor]="'blue'">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing"
                  | translate
              }}
            </nz-tag>
            <nz-tag *ngIf="isProcessingEnterprise(data.status) && isStoppedDocument()">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress"
                  | translate
              }}
            </nz-tag>
            <nz-tag *ngIf="data.status == enumContractEnterpriseStatus.REJECTED" [nzColor]="'red'">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied"
                  | translate
              }}
            </nz-tag>
            <nz-tag *ngIf="data.status == enumContractEnterpriseStatus.SIGNED" [nzColor]="'green'">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed"
                  | translate
              }}
            </nz-tag>
            <nz-tag *ngIf="data.status == enumContractEnterpriseStatus.CANCELLED" [nzColor]="'red'">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.cancel_flow"
                  | translate
              }}
            </nz-tag>
            <nz-tag *ngIf="data.status == enumContractEnterpriseStatus.STOP_PROCESS">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress"
                  | translate
              }}
            </nz-tag>
            <nz-tag *ngIf="data.status == enumContractEnterpriseStatus.DAEMON_PROCESSING && !isStoppedDocument()" [nzColor]="'orange'">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.daemon_processing"
                  | translate
              }}
            </nz-tag>
            <nz-tag *ngIf="data.status == 8" [nzColor]="'green'">
              {{ "contract_share_partner.issued" | translate }}
            </nz-tag>
          </td>
          <td (nzExpandChange)="mapOfExpandData[getPartyKey(data, i)] = $event"
              [nzExpand]="mapOfExpandData[getPartyKey(data, i)]"
              [nzShowExpand]="true">
          </td>
        </tr>
  
        <ng-container *ngFor="let user of getUsersByParty(data); let userIndex = index">
          <tr class="tr-user-data" *ngIf="mapOfExpandData[getPartyKey(data, i)]">
            <td></td>
            <td>
              {{ data.order || i + 1 }}.{{ userIndex + 1 }}. {{ getUserName(user) }}
              <span *ngIf="user.departmentName">
                ({{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.representative_name"
                    | translate
                }} {{ user.departmentName }})
              </span>
              <span *ngIf="(user.role == enumContractUserRole.APPROVE || user.role == 7) && user.isSignDigitalCertificate">
                <img src="assets/images/certificate-diploma3.svg"
                     title="{{ 'enterprise_contract.panel_document.table_parties.header.tooltip_sig_cts' | translate }}"
                     style="width: 16px; height: 16px;">
              </span>
            </td>
            <td class="text-center">
              <nz-tag *ngIf="user.status == enumContractUserStatus.NO_PROCESS">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.waiting"
                    | translate
                }}
              </nz-tag>
              <nz-tag *ngIf="isProcessingUser(user.status) && !isStoppedDocument()"
                      [nzColor]="user.status == enumContractUserStatus.DAEMON_PROCESSING ? 'orange' : 'blue'">
                <span *ngIf="user.role == enumContractUserRole.APPROVE || user.role == 7">
                  {{
                    "enterprise_contract.panel_document_view.table_signing_flow.user_status.approving"
                      | translate
                  }}
                </span>
                <span *ngIf="user.role == enumContractUserRole.SIGN || user.role == 6">
                  {{
                    "enterprise_contract.panel_document_view.table_signing_flow.user_status.signing"
                      | translate
                  }}
                </span>
                <span *ngIf="user.role == enumContractUserRole.INITIAL">
                  {{
                    "enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling"
                      | translate
                  }}
                </span>
              </nz-tag>
              <nz-tag *ngIf="(isProcessingUser(user.status) && isStoppedDocument()) || user.status == enumContractUserStatus.STOP_PROCESS">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.stop_progress"
                    | translate
                }}
              </nz-tag>
              <nz-tag *ngIf="user.status == enumContractUserStatus.REJECTED" [nzColor]="'red'">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.denied"
                    | translate
                }}
              </nz-tag>
              <nz-tag *ngIf="user.status == enumContractUserStatus.PROCESSED && (user.role == enumContractUserRole.APPROVE || user.role == 7)"
                      [nzColor]="'green'">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.approved"
                    | translate
                }}
              </nz-tag>
              <nz-tag *ngIf="user.status == enumContractUserStatus.PROCESSED && (user.role == enumContractUserRole.SIGN || user.role == 6)"
                      [nzColor]="'green'">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.signed"
                    | translate
                }}
              </nz-tag>
              <nz-tag *ngIf="user.status == enumContractUserStatus.CANCELLED" [nzColor]="'red'">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.user_status.cancel_flow"
                    | translate
                }}
              </nz-tag>
            </td>
            <td (nzExpandChange)="mapOfExpandData[getUserKey(user, userIndex)] = $event"
                [nzExpand]="mapOfExpandData[getUserKey(user, userIndex)]"
                [nzShowExpand]="true">
            </td>
          </tr>
  
          <tr *ngIf="mapOfExpandData[getPartyKey(data, i)] && mapOfExpandData[getUserKey(user, userIndex)]">
            <td></td>
            <td class="td-detail-data" colspan="2">
              <span *ngIf="user.comment">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.content"
                    | translate
                }}: {{ user.comment }}<br />
              </span>
              <!-- Vai trò -->
              <span *ngIf="user.role">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.role"
                    | translate
                }}: {{ getRoleLabelKey(user.role) | translate }}<br />
              </span>
              <span *ngIf="user.signingTime || user.rejectionTime || user.receivedAt">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.time"
                    | translate
                }}: {{ (user.signingTime || user.rejectionTime || user.receivedAt) | dateformattime }}<br />
              </span>
              <span *ngIf="user.certificateNo">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no"
                    | translate
                }}: {{ user.certificateNo }}<br />
              </span>
              <span *ngIf="getContactEmail(user) || getContactPhone(user)">
                {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.contact"
                    | translate
                }}: {{ getContactEmail(user) }} - {{ getContactPhone(user) }}
                <br />
              </span>
              <!-- Chức danh -->
              <span *ngIf="user.userPosition">
                {{
                  "form.userPosition"
                    | translate
                }}: {{ user.userPosition }}<br />
              </span>
              <!-- Thông tin ký -->
              <span *ngIf="user.signMethod != null && user.status == enumContractUserStatus.PROCESSED">
                <span>{{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_info" |
                  translate}}
                  :</span>

                <span *ngIf="user.signMethod == enumSignMethod.SIGN_USB_TOKEN" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_usb_token" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_SIM_CA" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_sim_ca" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_OTP" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_SERVER" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_hsm" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_IMAGE" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_image" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_NO_CERT" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_OTP_EKYC" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_OTP_EKYC_ADVANCED" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc_advanced" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_NO_CERT_EKYC" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert_ekyc" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.SIGN_NO_CERT_EKYC_ADVANCED" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert_ekyc_advanced" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.CLOUD_CA" class="ml-2">
                  - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_cloud_ca" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.EASY_CA" class="ml-2">
                  - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_easy_ca" |
                  translate}}
                </span>
                <span *ngIf="user.signMethod == enumSignMethod.VNEID" class="ml-2">
                  - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                  translate}}
                  :
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_vneid" |
                  translate}}
                </span>
                <span *ngIf="user.issuedTo && (user.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || user.signMethod == enumSignMethod.SIGN_SIM_CA
                        || user.signMethod == enumSignMethod.SIGN_SERVER
                        || user.signMethod == enumSignMethod.CLOUD_CA
                        || user.signMethod == enumSignMethod.VNEID
                        || user.signMethod == enumSignMethod.EASY_CA)" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to" |
                  translate}}
                  :
                  {{ user.issuedTo }}
                </span>
                <span *ngIf="user.serialNumber && (user.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || user.signMethod == enumSignMethod.SIGN_SIM_CA
                        || user.signMethod == enumSignMethod.SIGN_SERVER
                        || user.signMethod == enumSignMethod.CLOUD_CA
                        || user.signMethod == enumSignMethod.VNEID
                        || user.signMethod == enumSignMethod.EASY_CA)" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.serial_number" |
                  translate}}
                  :
                  {{ user.serialNumber }}
                </span>
                <span *ngIf="user.certificateNo && (user.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || user.signMethod == enumSignMethod.SIGN_SIM_CA
                        || user.signMethod == enumSignMethod.SIGN_SERVER
                        || user.signMethod == enumSignMethod.CLOUD_CA
                        || user.signMethod == enumSignMethod.VNEID
                        || user.signMethod == enumSignMethod.EASY_CA) " class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no" |
                  translate}}
                  :
                  {{ user.certificateNo }}
                </span>
                <span *ngIf="user.phoneNumber && (user.signMethod == enumSignMethod.SIGN_OTP
                        || user.signMethod == enumSignMethod.SIGN_SIM_CA)" class="ml-2">-
                  {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.phone_number" |
                  translate}}
                  :
                  {{ user.phoneNumber }}
                </span>
              </span>
              <!-- END of Thông tin ký -->
            </td>
            <td>&nbsp;</td>
          </tr>
        </ng-container>
  
        <tr *ngIf="mapOfExpandData[getPartyKey(data, i)] && getUsersByParty(data).length === 0">
          <td>&nbsp;</td>
          <td class="td-detail-data" colspan="2">
            <span *ngIf="data.comment">
              {{
                "enterprise_contract.panel_document_view.table_signing_flow.detail_content.content"
                  | translate
              }}: {{ data.comment }}<br />
            </span>
            <span *ngIf="data.taxCode">
              {{ "form.taxCode" | translate }}: {{ data.taxCode }}<br />
            </span>
            <span *ngIf="data.certificateNo">
              {{ "form.gpkd" | translate }} : {{ data.certificateNo }}<br />
            </span>
            <span *ngIf="getContactEmail(data) || getContactPhone(data)">
              {{ "footer.contact" | translate }}: {{ getContactEmail(data) }} - {{ getContactPhone(data) }}
              <br />
            </span>
          </td>
          <td>&nbsp;</td>
        </tr>
      </ng-container>
      </tbody>
    </nz-table>
    <ng-template #contentEmptyTable></ng-template>
  </div>
  